import { useQuery } from "@tanstack/react-query"
import { getMonthlyKpiSummary } from "api/employeeKpiApi"

export const useEmployeeKpiMonthlyReport = (month, year, extraParams = {}) => {
  return useQuery({
    queryKey: ["employee-kpi-monthly-report", month, year, extraParams],
    queryFn: () => getMonthlyKpiSummary({ month, year, ...extraParams }),
    staleTime: 1000 * 60 * 5,
  })
}
